<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">
        {{ $t("filmwisecollectionreport") }}
      </div>
      <div class="mt-3 mb-4 border-bottom">
        <div class="row">
          <!-- SELECT CINEMA -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="getFilmCollectionReportSelectedCinema ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :text="getFilmCollectionReportSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
                :disabled="isRoleID"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="
                    onDropdownSelectHandler({
                      event: $event,
                      name: 'Cinema',
                      selectedItem: dropdownItem,
                      index: dropdownIndex,
                    });
                    searchCinema = '';
                    onSearchCinema();
                    onSelectCinema(dropdownItem);
                  "
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <!-- START DATE -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getFilmCollectionReportFromDate"
                  v-on:click="
                    onFilmCollectionReportDateHandler({
                      event: null,
                      name: 'fromDate',
                    })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  :value="getFilmCollectionReportFromDate"
                  typeable
                  @selected="
                    onFilmCollectionReportDateHandler({
                      event: $event,
                      name: 'fromDate',
                    })
                  "
                  v-validate="'required'"
                ></Datepicker>
                <label :class="getFilmCollectionReportFromDate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("fromdate") }}</label
                >
              </div>
            </div>
          </div>

          <!-- END DATE -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getFilmCollectionReportToDate"
                  v-on:click="
                    onFilmCollectionReportDateHandler({
                      event: null,
                      name: 'toDate',
                    })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  :value="getFilmCollectionReportToDate"
                  typeable
                  @selected="
                    onFilmCollectionReportDateHandler({
                      event: $event,
                      name: 'toDate',
                    })
                  "
                  v-validate="'required'"
                ></Datepicker>
                <label :class="getFilmCollectionReportToDate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <!-- SELECT DISTRIBUTOR -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  getFilmCollectionReportSelectedDistributor
                    ? 'shift-up'
                    : 'd-none'
                "
                >{{ $tc("distributor", 1) }}</label
              >
              <!-- <b-dropdown
                :text="getFilmCollectionReportSelectedDistributor"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in getDistributorsList"
                  :key="dropdownIndex"
                  @click="onFilmCollectionReportDropdownHandler({ event: $event, name:'Distributor',selectedItem: dropdownItem, index:dropdownIndex })"
                >{{ dropdownItem.d_company_name }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :options="getDistributorsListWithAll"
                :searchable="true"
                :placeholder="
                  getFilmCollectionReportSelectedDistributor &&
                  getFilmCollectionReportSelectedDistributor.length > 0
                    ? getFilmCollectionReportSelectedDistributor
                    : 'Distributor'
                "
                label="d_company_name"
                track-by="d_id"
                @select="
                  onFilmCollectionReportDropdownHandler({
                    event: $event,
                    name: 'Distributor',
                    selectedItem: $event,
                  })
                "
                :allowEmpty="true"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>

          <!-- SELECT CINEMA -->
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  getFilmCollectionReportSelectedMovie ? 'shift-up' : 'd-none'
                "
                >{{ $tc("movie", 1) }}</label
              >
              <!-- <b-dropdown
                :text="getFilmCollectionReportSelectedMovie"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in getDistributorsMasterMovieList"
                  :key="dropdownIndex"
                  @click="onFilmCollectionReportDropdownHandler({ event: $event, name:'MasterMovie',selectedItem: dropdownItem, index:dropdownIndex })"
                >{{ dropdownItem.movie_title }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :options="MovieList"
                :searchable="true"
                :placeholder="
                  getFilmCollectionReportSelectedMovie &&
                  getFilmCollectionReportSelectedMovie.length > 0
                    ? getFilmCollectionReportSelectedMovie
                    : 'Movie'
                "
                label="movie"
                track-by="md_id"
                @select="
                  onFilmCollectionReportDropdownHandler({
                    event: $event,
                    name: 'MasterMovie',
                    selectedItem: $event,
                  })
                "
                :allowEmpty="true"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>

          <div
            class="col-lg-6 col-xl-3 align-self-center mb-3"
            v-if="isCinemaAkhil"
          >
            <div class="dropdown-curve-container">
              <label :class="selectedCategoryName ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("Category", 1) }}</label
              >
              <multiselect
                v-model="selectedScheduleCategory"
                track-by="ss_category_id"
                label="ss_category_name"
                @select="onSelectScheduleCategory($event, $event)"
                @remove="onRemoveSelectScheduleCategory($event, $event)"
                :options="scheduleCategoryList"
                :multiple="false"
              ></multiselect>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              @click.prevent.stop="fetchFilmCollectionReportListv2"
              class="btn-blue-lg w-100"
            >
              {{ $tc("Fetch Report") }}
            </button>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-5 align-items-center">
        <div>{{ $t("download") }} as:</div>
        <a
          v-if="getFilmCollectionPDFFileName"
          :href="BASE_URL + getFilmCollectionPDFFileName"
          target="_blank"
          download
          title="Download as PDF"
        >
          <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
        </a>
        <a
          v-if="getFilmCollectionExcelFileName"
          :href="BASE_URL + getFilmCollectionExcelFileName"
          target="_blank"
          title="Download as Excel"
          download
        >
          <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
        </a>
      </div>

      <div v-if="getFilmCollectionReportList.length === 0" class="swc-report">
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th class="bg-lightgrey text-left">{{ $tc("screen", 1) }}</th>
              <th class="bg-lightgrey">{{ $t("show") }} {{ $t("time") }}</th>
              <th class="bg-lightgrey">{{ $t("show") }} {{ $t("date") }}</th>
              <th class="bg-lightgrey">{{ $tc("shift", 1) }}</th>
              <th class="bg-lightgrey">{{ $t("class") }}</th>
              <th class="bg-lightgrey">
                {{ $tc("ticket", 1) }} {{ $tc("type", 1) }}
              </th>
              <th class="bg-lightgrey">{{ $t("rate") }}</th>
              <th class="bg-lightgrey">{{ $t("sold") }}</th>
              <th class="bg-lightgrey">{{ $t("sold") }} {{ $t("amount") }}</th>
              <th class="bg-lightgrey">{{ $t("offer") }} {{ $t("amount") }}</th>
              <th class="bg-lightgrey">
                {{ $t("Complimentary") }} {{ $t("Tickets") }}
              </th>
              <th class="bg-lightgrey">
                {{ $t("Total") }} {{ $t("Tickets") }}
              </th>
              <th class="bg-lightgrey">{{ $t("tax") }}</th>
              <th class="bg-lightgrey text-right">
                {{ $t("net") }} {{ $t("amount") }}
              </th>
            </tr>
          </thead>

          <tr>
            <td colspan="14">
              <!-- <p class="h6 mb-0 text-center">{{ $t("NoRecords") }}</p> -->
              <NoRecords />
            </td>
          </tr>
          <!-- <tr class="text-right bg-lightgrey">
            <th colspan="4">Total od VALMIKI (2D) (Telugu) (15+)</th>
            <th></th>
            <th>36</th>
            <th>1,187.03</th>
            <th>56.53</th>
            <th>1,073.98</th>
          </tr>
          <tr class="text-right bg-lightgrey">
            <th colspan="4">Grand Total</th>
            <th></th>
            <th>4167</th>
            <th>187,202.01</th>
            <th>8,914.38</th>
            <th>169,373.25</th>
          </tr>-->
        </table>
      </div>

      <div v-if="getFilmCollectionReportList.length > 0" class="swc-report">
        <div class="table-scroll">
          <table class="swc-report-table filmwise-report-table" border="1">
            <thead ref="swcTheadRef">
              <tr>
                <th class="bg-lightgrey">{{ $tc("screen", 1) }}</th>
                <th class="bg-lightgrey">{{ $t("show") }} {{ $t("time") }}</th>
                <th class="bg-lightgrey">{{ $t("show") }} {{ $t("date") }}</th>
                <th class="bg-lightgrey">{{ $tc("shift", 1) }}</th>
                <th class="bg-lightgrey">{{ $t("class") }}</th>
                <th class="bg-lightgrey">
                  {{ $tc("ticket", 1) }} {{ $tc("type", 1) }}
                </th>
                <th class="bg-lightgrey">{{ $t("rate") }}</th>
                <th class="bg-lightgrey">{{ $t("sold") }}</th>
                <th class="bg-lightgrey">
                  {{ $t("gross") }} {{ $t("amount") }}
                </th>
                <th class="bg-lightgrey">
                  {{ $t("Complimentary") }} {{ $t("Tickets") }}
                </th>
                <th class="bg-lightgrey">
                  {{ $t("Total") }} {{ $t("Tickets") }}
                </th>
                <!-- <th class="bg-lightgrey">{{ $t("discount") }}</th> -->

                <th
                  v-for="(FilmCollectionReportCharge,
                  FilmCollectionReportChargeIndex) in getFilmCollectionReportChargeList"
                  :key="FilmCollectionReportChargeIndex"
                  class="bg-lightgrey"
                >
                  {{ FilmCollectionReportCharge.ct_name }}
                </th>
                <!-- <th class="bg-lightgrey">M.Tax</th>
              <th class="bg-lightgrey">Tax</th>-->
                <th class="bg-lightgrey">{{ $t("net") }} {{ $t("amount") }}</th>
              </tr>
            </thead>
            <div
              v-for="(FilmCollection,
              FilmCollectionIndex) in getFilmCollectionReportList"
              :key="FilmCollectionIndex + 'Film'"
            >
              <!-- <tr> -->
              <!-- <td :colspan="tdSpan"> -->
              <!-- <table class="swc-report-table" border="1"> -->
              <tbody>
                <tr>
                  <td
                    v-if="FilmCollectionIndex !== 0"
                    :colspan="13 + getFilmCollectionReportChargeList.length"
                  >
                    <div class="p-3"></div>
                  </td>
                </tr>
                <tr>
                  <td
                    :colspan="13 + getFilmCollectionReportChargeList.length"
                    class="p-0"
                  >
                    <div
                      class="bg-lightgrey d-flex w-100 justify-content-start py-2 border-top border-dark"
                      style="padding-left: 2px; padding-right: 2px"
                    >
                      <div class="mr-3">
                        <strong
                          >{{ FilmCollection[0].Data[0].movie_name }},
                          {{ $tc("distributor", 1) }} :
                          {{
                            FilmCollection[0].Data[0].dist_company_name
                          }}</strong
                        >
                      </div>
                      <!--<div>
                        <strong
                          v-if="getFilmCollectionReportSelectedDistributor"
                          >{{ $tc("distributor", 1) }} :
                          {{
                            getFilmCollectionReportSelectedDistributor
                          }}</strong
                        >
                      </div>-->
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody
                v-for="(Screen, ScreenIndex) in FilmCollection"
                :key="ScreenIndex"
              >
                <tr
                  v-for="(Show, ShowIndex) in Screen.Data"
                  :key="ShowIndex + Show.screen_name"
                >
                  <td>{{ Show.screen_name }}</td>
                  <td>
                    {{ moment(Show.t_show_time, "HH:mm:ss").format("HH:mm") }}
                  </td>
                  <td>{{ Show.show_date }}</td>
                  <td>{{ Show.shift_name }}</td>
                  <td>{{ Show.seat_type_name }}</td>
                  <td>{{ Show.ticket_type_name }}</td>
                  <td>{{ currFormat(Show.rate) }}</td>
                  <!-- <td>{{ Show['ShowNo'] ? Show['ShowNo'] : '-' }}</td>
              <td>{{ Show['Amount'] ? Show['Amount'] : '-' }}</td>-->
                  <td>{{ Show.Sold }}</td>
                  <td>{{ currFormat(Show.gross_amount) }}</td>
                  <td>{{ Show.compplementory_ticket }}</td>
                  <td>{{ Show.compplementory_ticket + Show.Sold }}</td>
                  <!-- <td>{{ currFormat(Show.offer_price) }}</td> -->
                  <!-- <td
                v-for="(ChargeItem, ChargeIndex) in Show.taxes"
                :key="ChargeIndex+ChargeItem.ChargeName+ChargeItem.ct_name"
              >
                <div>&nbsp;</div>
                <div>{{ ChargeItem['SUM(ts.sp_value)'] }}</div>
              </td>-->
                  <td
                    v-for="(FilmCollectionReportCharge,
                    FilmCollectionReportChargeIndex) in getFilmCollectionReportChargeList"
                    :key="FilmCollectionReportChargeIndex"
                  >
                    {{
                      Show[
                        FilmCollectionReportCharge.ct_name +
                          "_" +
                          FilmCollectionReportCharge.ct_id
                      ]
                        ? currFormat(
                            Show[
                              FilmCollectionReportCharge.ct_name +
                                "_" +
                                FilmCollectionReportCharge.ct_id
                            ]
                          ) || "-"
                        : "_"
                    }}
                  </td>
                  <!-- <td>H-85.00</td>
              <td>H-85.00</td>-->
                  <td>
                    {{
                      currFormat(
                        parseFloat(Show.t_net_amount) * parseFloat(Show.Sold)
                      ) || "-"
                    }}
                  </td>
                </tr>

                <tr>
                  <th class="bg-lightgrey" colspan="8">
                    <strong>{{ $t("total") }}</strong>
                  </th>
                  <!-- <th class="bg-lightgrey"></th> -->

                  <th class="bg-lightgrey">
                    {{
                      currFormat(
                        Screen.Data.reduce(
                          (accumulator, { gross_amount }) =>
                            accumulator + parseFloat(gross_amount),
                          0
                        )
                      ) || "-"
                    }}
                  </th>
                  <th class="bg-lightgrey">
                    {{
                      Screen.Data.reduce(
                        (accumulator, { compplementory_ticket }) =>
                          accumulator + parseFloat(compplementory_ticket),
                        0
                      ) || "-"
                    }}
                  </th>
                  <th class="bg-lightgrey">
                    {{
                      Screen.Data.reduce(
                        (accumulator, { Sold, compplementory_ticket }) =>
                          accumulator +
                          parseFloat(Sold) +
                          parseFloat(compplementory_ticket),
                        0
                      ) || "-"
                    }}
                  </th>
                  <!-- <th class="bg-lightgrey">
                    {{
                      currFormat(
                        Screen.Data.reduce(
                          (accumulator, { offer_price }) =>
                            accumulator + parseFloat(offer_price),
                          0
                        )
                      ) || "-"
                    }}
                  </th> -->
                  <th
                    v-for="(FilmCollectionReportCharge,
                    FilmCollectionReportChargeIndex) in getFilmCollectionReportChargeList"
                    :key="FilmCollectionReportChargeIndex + '_Charges'"
                    class="bg-lightgrey"
                  >
                    {{
                      Screen.Data.reduce(
                        (accumulator, obj) =>
                          accumulator +
                          (obj[
                            FilmCollectionReportCharge.ct_name +
                              "_" +
                              FilmCollectionReportCharge.ct_id
                          ] == null
                            ? (obj[
                                FilmCollectionReportCharge.ct_name +
                                  "_" +
                                  FilmCollectionReportCharge.ct_id
                              ] = 0)
                            : obj[
                                FilmCollectionReportCharge.ct_name +
                                  "_" +
                                  FilmCollectionReportCharge.ct_id
                              ]),
                        0
                      ).toFixed(MIN_FRACTION_DIGITS) === "0.00"
                        ? "-"
                        : currFormat(
                            Screen.Data.reduce(
                              (accumulator, obj) =>
                                accumulator +
                                (obj[
                                  FilmCollectionReportCharge.ct_name +
                                    "_" +
                                    FilmCollectionReportCharge.ct_id
                                ] == null
                                  ? (obj[
                                      FilmCollectionReportCharge.ct_name +
                                        "_" +
                                        FilmCollectionReportCharge.ct_id
                                    ] = 0)
                                  : obj[
                                      FilmCollectionReportCharge.ct_name +
                                        "_" +
                                        FilmCollectionReportCharge.ct_id
                                    ]),
                              0
                            )
                          )
                    }}
                    <!-- <td class="bg-lightgrey">85.00</td>
                <td class="bg-lightgrey">85.00</td>-->
                  </th>
                  <th class="bg-lightgrey">
                    {{
                      currFormat(
                        Screen.Data.reduce(
                          (accumulator, { t_net_amount, Sold }) =>
                            accumulator +
                            parseFloat(t_net_amount) * parseFloat(Sold),
                          0
                        )
                      ) || "-"
                    }}
                  </th>
                </tr>
              </tbody>
              <tbody>
                <tr>
                  <th class="color-blue" colspan="8">
                    <strong>{{ $t("Film") }} {{ $t("total") }}</strong>
                  </th>

                  <th class="color-blue">
                    {{
                      currFormat(
                        FilmCollection.reduce(function(a, b) {
                          b.Data.forEach(function(c) {
                            a += c.gross_amount;
                          });
                          return a;
                        }, 0)
                      ) || "-"
                    }}
                  </th>
                  <th class="color-blue">
                    {{
                      FilmCollection.reduce(function(a, b) {
                        b.Data.forEach(function(c) {
                          a += c.compplementory_ticket;
                        });
                        return a;
                      }, 0)
                    }}
                  </th>
                  <th class="color-blue">
                    {{
                      FilmCollection.reduce(function(a, b) {
                        b.Data.forEach(function(c) {
                          a +=
                            parseFloat(c.Sold) +
                            parseFloat(c.compplementory_ticket);
                        });
                        return a;
                      }, 0)
                    }}
                  </th>
                  <th
                    v-for="(FilmCollectionReportCharge,
                    FilmCollectionReportChargeIndex) in getFilmCollectionReportChargeList"
                    :key="FilmCollectionReportChargeIndex + '_Charges'"
                    class="color-blue"
                  >
                    {{
                      FilmCollection.reduce(function(a, b) {
                        b.Data.forEach(function(obj) {
                          a +=
                            obj[
                              FilmCollectionReportCharge.ct_name +
                                "_" +
                                FilmCollectionReportCharge.ct_id
                            ] == null
                              ? (obj[
                                  FilmCollectionReportCharge.ct_name +
                                    "_" +
                                    FilmCollectionReportCharge.ct_id
                                ] = 0)
                              : obj[
                                  FilmCollectionReportCharge.ct_name +
                                    "_" +
                                    FilmCollectionReportCharge.ct_id
                                ];
                        });
                        return a;
                      }, 0).toFixed(MIN_FRACTION_DIGITS) === "0.00"
                        ? "-"
                        : currFormat(
                            FilmCollection.reduce(function(a, b) {
                              b.Data.forEach(function(obj) {
                                a +=
                                  obj[
                                    FilmCollectionReportCharge.ct_name +
                                      "_" +
                                      FilmCollectionReportCharge.ct_id
                                  ] == null
                                    ? (obj[
                                        FilmCollectionReportCharge.ct_name +
                                          "_" +
                                          FilmCollectionReportCharge.ct_id
                                      ] = 0)
                                    : obj[
                                        FilmCollectionReportCharge.ct_name +
                                          "_" +
                                          FilmCollectionReportCharge.ct_id
                                      ];
                              });
                              return a;
                            }, 0)
                          )
                    }}
                  </th>
                  <th class="color-blue">
                    {{
                      currFormat(
                        FilmCollection.reduce(function(a, b) {
                          b.Data.forEach(function(c) {
                            a +=
                              parseFloat(c.Sold) * parseFloat(c.t_net_amount);
                          });
                          return a;
                        }, 0)
                      )
                    }}
                  </th>
                </tr>
              </tbody>
            </div>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from "vuex";
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import MovieService from "@/services/MovieService";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import { Role, CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";

  export default {
    components: {
      NoRecords,
    },
    data() {
      return {
        scheduleCategoryList: [],
        selectedScheduleCategoryId: null,
        selectedCategoryName: "",
        selectedScheduleCategory: {},
        BASEURL,
        Cinemas: [],
        MovieList: [],
        isRoleID: true,
        CinemasCopy: [],
        searchCinema: "",
        selectedCinemaId: undefined,
        // tdSpan:14
      };
    },
    computed: {
      isCinemaAkhil() {
        return CLIENT_NAMES_OBJ.cinemaakhil == this.CLIENT_SETUP_NAME;
      },
      ...mapGetters([
        // Flags
        "getFilmCollectionReportsIsCinema",
        // End
        // DropDownList
        "getDistributorsList",
        "getCinemasList",
        // "getFilmCollectionReportMoviesList",
        "getDistributorsMasterMovieList",
        "getFilmCollectionReportChargeList",
        // DropDown
        "getFilmCollectionReportList",
        "getFilmCollectionReportToDate",
        "getFilmCollectionReportFromDate",
        // Get DropDown Selected Values
        "getFilmCollectionReportSelectedDistributor",
        "getFilmCollectionReportSelectedCinema",
        "getFilmCollectionReportSelectedMovie",
        // EXCEL
        "getFilmCollectionExcelFileName",

        // PDF
        "getFilmCollectionPDFFileName",
      ]),
      getDistributorsListWithAll: function() {
        let list = [{ d_id: 99999999, d_company_name: "All" }];
        if (this.getDistributorsList) {
          return list.concat(this.getDistributorsList);
        }
        return list;
      },
    },
    beforeMount() {
      let roleid = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
      }
      let cinemaId =
        this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO")["cinema_id"]
          ? this.secureStore.get("USINFO").cinema_id
          : null;
      // this.onFilmCollectionReportFlagHandler({
      //   event: null,
      //   name: "isCinema",
      //   value: cinemaId
      // });
      this.onFilmCollectionReportFlagHandler({
        event: null,
        name: "isCountry",
        value: this.secureStore.get("BRGLOPCO") || null,
      });
      this.getCinemaList(cinemaId);
      // this.fetchCinemasList({ cinemaId });
      this.fetchDistributorsList();
      this.getMoviesList();

      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      if (CinemaObj) {
        this.onFilmCollectionReportDropdownHandler({
          event: null,
          name: "Cinema",
          selectedItem: CinemaObj,
        });
        this.selectedCinemaId = CinemaObj.cine_id;
      }
      this.getShowScheduleCategories();
      // this.fetchDistributorsActiveMasterMovie();
    },
    watch: {
      "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
        if (CinemaObj) {
          this.onFilmCollectionReportDropdownHandler({
            event: null,
            name: "Cinema",
            selectedItem: CinemaObj,
          });
          this.selectedCinemaId = CinemaObj.cine_id;
        }
      },
    },
    mounted() {
      // tdspan = this.$refs.swcTheadRef.children.length;
    },
    methods: {
      moment,
      getShowScheduleCategories() {
        let payload = {
          tableName: "schedule_show_categories",
          is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.scheduleCategoryList = data.Records.reverse();
            } else {
              // Show Error Message:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error on getActiveScreenByCinemaId :", error);
          });
      },
      onSelectScheduleCategory(event, category) {
        console.log("selectCategory=>");
        this.selectedCategoryName = category.ss_category_name;
        this.selectedScheduleCategoryId = category.ss_category_id;
        this.selectedScheduleCategory = category;
        this.onFilmCollectionReportDropdownHandler({
          name: "ScheduleCategory",
          selectedItem: { ss_show_category_id: category.ss_category_id },
        });
        // this.isChanged = true;
      },
      onRemoveSelectScheduleCategory() {
        console.log("selectCategory=>");
        this.selectedScheduleCategoryId = null;
        this.selectedCategoryName = "";
        this.selectedScheduleCategory = null;
      },
      ...mapActions([
        //
        "fetchCinemasList",
        "fetchDistributorsList",
        "fetchDistributorsActiveMasterMovie",
        //
        "fetchFilmCollectionReportListv2",
        "onFilmCollectionReportDateHandler",
        "onFilmCollectionReportDropdownHandler",
        "onFilmCollectionReportFlagHandler",
        // RESET STORE
        "onResetFilmCollectionReportStoreState",
      ]),
      onSelectCinema(cinema) {
        console.log("");
        this.$store.dispatch("selectDropdownCinema", cinema);
      },
      onDropdownSelectHandler: function(payload) {
        if (payload.name === "Cinema") {
          this.onFilmCollectionReportDropdownHandler(payload);
          // this.onFilmCollectionReportDropdownHandler({
          //   name: "MasterMovie",
          //   selectedItem: null
          // });
          this.selectedCinemaId = payload.selectedItem.cine_id;
          this.getMoviesList();
        }
      },
      onSearchCinema: function() {
        if (this.searchCinema && this.searchCinema.length > 0) {
          this.Cinemas = this.CinemasCopy.filter((x) => {
            if (
              x.cine_name
                .toLowerCase()
                .includes(this.searchCinema.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.Cinemas = this.CinemasCopy;
        }
      },
      getMoviesList: function() {
        MovieService.GetActiveMoviesWithFormat({
          cinema_id: this.selectedCinemaId,
        })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.MovieList = [
                {
                  movie: "All",
                  md_id: 99999999,
                  movie_id: 99999999,
                  movie_title: "All",
                },
                ...data.Records,
              ];
            } else {
              console.log("Error:", data.message);
              // this.$toasted.show(
              //   data.message ||
              //     "Sorry! Something went wrong. kindly contact your administrator"
              // );
            }
          })
          .catch(this._CatchError);
      },
      getCinemaList: function(cine_id) {
        this.Cinemas = [];
        //  let payload = null
        //   cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
        MasterService.GetCinemas({ cine_id: cine_id })
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
              this.CinemasCopy = data.Records;
              // this.CinemasCopy = data.Records;
              this.Cinemas.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  // let cinema = {
                  //   cine_name: x.cine_name,
                  //   cine_id: x.cine_id
                  // };

                  // this.onSelectCinema(null,cinema);
                  this.onFilmCollectionReportFlagHandler({
                    event: null,
                    name: "isCinema",
                    value: x.cine_id,
                    cine_name: x.cine_name,
                  });
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
    },
    beforeDestroy: async function() {
      await this.$store.dispatch("globalRemoveFile", {
        fileName: this.getFilmCollectionExcelFileName,
      });
      await this.$store.dispatch("globalRemoveFile", {
        fileName: this.getFilmCollectionPDFFileName,
      });
      await this.onResetFilmCollectionReportStoreState();
    },
  };
</script>
<style>
  .swc-report-table th,
  .swc-report-table td {
    padding: 5px 15px 5px 15px;
  }

  /* .align-first-left tr > th:first-child,
tr > td:first-child {
  text-align: left;
  padding-left: 2px;
} */

  /* .align-last-right tr > th:last-child,
tr > td:last-child {
  text-align: right;
  padding-right: 2px;
} */

  /* .filmwise-report-table{
  white-space: normal;
  table-layout: fixed !important;
} */

  .filmwise-report-table > div {
    display: contents;
  }

  .filmwise-report-table td,
  .filmwise-report-table th {
    border-color: #787878;
  }

  .color-blue {
    background: #c1d7eb;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/filmWiseCollectionReport-v2.vue